// extracted by mini-css-extract-plugin
export var attachment = "_ns-a";
export var emailContainer = "_ns-4";
export var emailContentPaddedContainer = "_ns-b";
export var emailHeader = "_ns-6";
export var emailIframe = "_ns-3";
export var emailInfoIcon = "_ns-9";
export var emailShortenedSummary = "_ns-e";
export var infoDropdown = "_ns-0";
export var infoRowBoundedContent = "_ns-d";
export var internal = "_ns-5";
export var merchant = "_ns-8";
export var messageInputContainer = "_ns-h";
export var normal = "_ns-7";
export var replyCard = "_ns-f";
export var subtleButton = "_ns-1";
export var subtleButtonIconContainer = "_ns-2";
export var toggleViewRepliesButton = "_ns-c";
export var wrappingText = "_ns-g";